const bannerTypes = [
  {id: 'none', name: '없음'},
  {id: 'url', name: 'URL'},
  {id: 'goods', name: '상품'},
  {id: 'products', name: '품목'}
]

export {bannerTypes}
